"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMarginMutation = void 0;
const types_1 = require("../../types");
exports.createMarginMutation = `
  mutation createMargin($orderId: String!, $input: MarginInput!) {
    createMargin(orderId: $orderId, input: $input) {
      ...margin
    }
  }
  ${types_1.marginFragment}
`;
//# sourceMappingURL=margin.js.map